import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { toString } from "qrcode";
import { defineComponent, watch, openBlock, createElementBlock } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
const _hoisted_1 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsQrCode",
  props: {
    content: { type: String, default: "" }
  },
  setup(__props) {
    const props = __props;
    const qrSvg = ref("");
    const updateQrContents = () => toString(
      props.content,
      {
        errorCorrectionLevel: "L",
        // Low
        type: "svg",
        width: 200,
        margin: 0
      },
      (err, url) => {
        qrSvg.value = url;
      }
    );
    watch(
      () => props.content,
      () => {
        updateQrContents();
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "qr-code-wrapper",
        innerHTML: qrSvg.value
      }, null, 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsQrCode.vue.es2.js.map
